// generated by genversion
export var version = '5.0.7';
//# sourceMappingURL=version.js.map